import { Injectable } from '@angular/core';
import { takeUntil } from 'rxjs';
import { Bloc, ErrorState, ShowPopUpLoadingState, ShowSuccessMessageState } from 'src/app/shared/bloc/base-bloc';
import { NonDrawing } from 'src/app/shared/model';

import { ConfirmationEvent, ConfirmationSubmitEvent } from './confiramtion-event';
import { ConfirmationReadyState, ConfirmationState } from './confiramtion-state';

@Injectable()
export class ConfirmationBloc extends Bloc<ConfirmationEvent, ConfirmationState> {
  constructor() {
    super();
  }
  onIncomingEvents(event: ConfirmationEvent): void {
    if (event instanceof ConfirmationSubmitEvent) {
      // loading component
      this.onState$.next(new ShowPopUpLoadingState());
      // call api
      event.caller(event.action)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.onState$.next(new ShowSuccessMessageState(new ConfirmationReadyState(result) , "DONE"));
          },
          error: (error) => {
            this.onState$.next(new ErrorState<NonDrawing>(new NonDrawing(), error));
          },
        });
    }
  }
}
